
<div id="form-depot-choix" class="mb-6">
  <LimiteDepotSection :categories="categories" :period="period" :content="content" />
</div>
